module.exports = __webpack_public_path__ + "images/data5.png";